/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestedRepairOrder
 */
export interface RequestedRepairOrder {
    /**
     * 
     * @type {string}
     * @memberof RequestedRepairOrder
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestedRepairOrder
     */
    wipNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestedRepairOrder
     */
    wipId: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestedRepairOrder
     */
    requestType: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RequestedRepairOrder
     */
    requestedDate?: Date | null;
}

/**
 * Check if a given object implements the RequestedRepairOrder interface.
 */
export function instanceOfRequestedRepairOrder(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "wipNumber" in value;
    isInstance = isInstance && "wipId" in value;
    isInstance = isInstance && "requestType" in value;

    return isInstance;
}

export function RequestedRepairOrderFromJSON(json: any): RequestedRepairOrder {
    return RequestedRepairOrderFromJSONTyped(json, false);
}

export function RequestedRepairOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestedRepairOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'wipNumber': json['wipNumber'],
        'wipId': json['wipId'],
        'requestType': json['requestType'],
        'requestedDate': !exists(json, 'requestedDate') ? undefined : (json['requestedDate'] === null ? null : new Date(json['requestedDate'])),
    };
}

export function RequestedRepairOrderToJSON(value?: RequestedRepairOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'wipNumber': value.wipNumber,
        'wipId': value.wipId,
        'requestType': value.requestType,
        'requestedDate': value.requestedDate === undefined ? undefined : (value.requestedDate === null ? null : value.requestedDate.toISOString()),
    };
}

